import { FC } from 'react';
import { UserEventModel } from '@/lib/models/user-event/user-event.model';
import Conversation from '../../conversation';
import { useQuery } from 'react-query';
import { getUserEventWithPartialConversation } from '@/lib/services/user-event.service';
import { QueryKey } from '@/lib/query-client';
import useQueryHelper from '@/hooks/use-query-helper';

interface Props {
  userEvent: UserEventModel;
}

const EventMessages: FC<Props> = ({ userEvent }) => {
  const { id } = userEvent;
  const query = useQuery([QueryKey.UserEventViewWithPartialConversation, id], async () =>
    getUserEventWithPartialConversation(id)
  );
  const { showLoader } = useQueryHelper(query);
  const { data } = query;
  const event = data || new UserEventModel();
  return (
    <Conversation
      userEvent={event}
      variant="user-event"
      anchorActivityId={id}
      isLoading={showLoader}
    />
  );
};

export default EventMessages;
